import { Component } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { StorageService } from './../../providers/storage.service';
import { WithdrawRecordService } from './../../services/withdrawRecord.service';
import { WithdrawRecordModel } from './../../models/withdrawRecord.model';
import { LoaddingService } from './../../providers/loadding.service';
import { ToastService } from './../../providers/toast.service';
import { PageDefault } from '../../pages/PageDefault';
import { UserModel } from './../../models/user.model';
import { WithdrawSearch } from './withdrawsearch';
import * as moment from 'moment';

@Component({
  selector: 'page-withdraw-record',
  templateUrl: 'withdraw-record.html',
  providers: [WithdrawRecordService]
})

export class WithdrawRecordPage {
  constructor(
    public storage: StorageService,
    private toast:ToastService,
    public withdrawRecordService: WithdrawRecordService,
    private loadding: LoaddingService,
    private modalCtrl: ModalController
  ) { }
  records: WithdrawRecordModel[]=[];
  excludeTracks = [];
  isHave: boolean = false;
  username = this.storage.read<UserModel>("User").UserName;
  site = new WithdrawSearchInput();
  amount: number;
  pagesize:number=PageDefault.PageSize();
  hasmore:boolean=false;


    //查询点击事件
  record(obj:WithdrawSearchInput) {
    return this.withdrawRecordService.getWithdrawRecord(obj.UserName, obj.StartDate, obj.EndDate, obj.PageSize, obj.PageIndex).then(s => {
      if (s.List != null) {
        if (obj.PageIndex == 1) {
          this.records = [];
          this.records = s.List;
          if (s.List.length < s.PageCount) {
            this.hasmore = true;
          } else {
            this.hasmore = false;
          }
        } else {
          this.records = this.records.concat(s.List);
          if (this.records.length < s.PageCount) {
            this.hasmore = true;
          }
          else {
            obj.PageIndex = 1;
            this.hasmore = false;
          }
        }
      } else {
        this.records = [];
      }
      this.records.forEach(t=>{
        t.AddTime = moment(t.AddTime, moment.ISO_8601).format("YYYY-MM-DD HH:mm:ss");
    });
      if (this.records.length < 1) {
        this.isHave = false;
      } else {
        this.isHave = true;
      }
    });
  }


  //查询条件
  presentFilter() {
    let modal = this.modalCtrl.create(WithdrawSearch, this.excludeTracks);
    modal.present();
    modal.onWillDismiss((data: any[]) => {
      if (data) {
        this.excludeTracks = data;
        this.site.UserName = this.username;
        this.site.StartDate = this.excludeTracks["startDate"];
        this.site.EndDate = this.excludeTracks["endDate"];
        this.site.PageIndex=this.excludeTracks["pageIndex"];
        this.record(this.site);
      }
    });
  }

  //页面加载
  ionViewDidLoad() {
    let load = this.loadding.showLoding();
    this.site.UserName = this.username;
    this.record(this.site).then(s => {
      this.loadding.closeLoading(load);
    });
  }


  //下拉重新加载
  //TQQ 2016-12-29
  doRefresh(refresher) {
    this.site.PageIndex = 1;
    this.record(this.site).then(s => {
      refresher.complete();
    });
  }

  //上拉获取下一页信息
  //chen 2017-02-18
  doInfinite(infiniteScroll) {
    this.site.PageIndex++;
    this.record(this.site).then(s => {
      infiniteScroll.complete();
    });
  }
}

export class WithdrawSearchInput {
  UserName: string;
  StartDate: string = PageDefault.startDate();
  EndDate: string = PageDefault.endDate();
  PageIndex: number = 1;
  PageSize: number = PageDefault.PageSize();
}



// WEBPACK FOOTER //
// ./src/pages/withdraw-record/withdraw-record.ts